"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";

const cards = [
  {
    number: "01",
    title: "Newly incorporated companies",
    description:
      "Every Hong Kong company must maintain statutory records and compliance support from incorporation onward.",
  },
  {
    number: "02",
    title: "Businesses making structural changes",
    description:
      "When directors, shareholders, or ownership changes occur, filings must be prepared correctly.",
  },
  {
    number: "03",
    title: "Founders maintaining offshore eligibility",
    description:
      "Incomplete records or missed filings can affect compliance status. Proper coordination helps protect your structure long-term.",
  },
];

export default function SecretarySupport({ heading = "Why Corporate Secretary Support Matters for Hong Kong Companies" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black py-[60px] lg:py-[100px] px-4 min-[1340px]:px-0">
      <div className="max-w-[1200px] mx-auto flex flex-col items-center gap-10 lg:gap-14">
        {/* TITLE */}
        <Heading as="h2" variant="sectionCentered" className="max-w-[1200px]">
          {heading}
        </Heading>

        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 w-full">
          {cards.map((card) => (
            <div
              key={card.number}
              className="group relative bg-[#0f1218] border border-white/10 rounded-2xl p-7 flex flex-col gap-4 overflow-hidden after:absolute after:bottom-0 after:left-0 after:w-full after:h-[3px] after:bg-[#335CFF] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:origin-left"
            >
              <span className="text-[55px] leading-[120%] font-inter font-semibold text-white opacity-20 group-hover:opacity-50 transition-colors duration-300 select-none">
                {card.number}
              </span>
              <h3 className="text-[16px] lg:text-[20px] font-semibold leading-[120%] text-white font-inter">
                {card.title}
              </h3>
              <p className="text-[14px] lg:text-[16px] leading-[150%] text-white/70 font-inter font-normal">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
